<template>
  <div class="authenticated">
    <div class="nav-bg container-fluid">
      <navigation></navigation>
    </div>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger"></alert>
        <alert v-if="isMessage" type="primary"></alert>
        <p><em>Last Updated: {{ lastRefreshDate }}</em> <b-button @click="refreshPage" variant="link"><em>Refresh</em></b-button></p>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'
  import SvSchedule from '@/components/schedule/SvSchedule'
  import TlSchedule from '@/components/schedule/TlSchedule'
  export default {
    name: 'Schedule',
    data () {
      return {}
    },
    computed: {
      ...mapGetters(['isError', 'isMessage']),
      ...mapState('user', ['isTeamLeader']),
      ...mapState('schedule', ['lastRefreshDate'])
    },
    methods: {
      refreshPage: function () {
        location.reload()
      }
    },
    components: {
      alert: Alert,
      navigation: Nav,
      svSchedule: SvSchedule,
      tlSchedule: TlSchedule
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schedule/Schedule.vue